<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="rows"
    :loading="loading"
    row-key="id"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Leave_Type'">
        <div class="d-flex align-items-center">
          <p class="fs-14 fw-medium d-flex align-items-center mb-0">
            {{ record.leave_type?.name || "-" }}
            <span v-if="record.half_day" class="badge bg-info-transparent ms-2">Half day</span>
          </p>
          <a
            v-if="record.reason"
            href="javascript:void(0);"
            class="ms-2"
            data-bs-toggle="tooltip"
            :data-bs-title="record.reason"
          >
            <i class="ti ti-info-circle text-info"></i>
          </a>
        </div>
      </template>

      <template v-else-if="column.key === 'Approved_By'">
        <div class="d-flex align-items-center file-name-icon">
          <div class="ms-2">
            <h6 class="fw-medium mb-0">{{ record.approved_by_name || "-" }}</h6>
            <span class="fs-12 fw-normal">{{ record.approved_by_role || "" }}</span>
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'From'">
        {{ formatDate(record.from_date) }}
      </template>

      <template v-else-if="column.key === 'To'">
        {{ formatDate(record.to_date) }}
      </template>

      <template v-else-if="column.key === 'No_of_Days'">
        {{ formatDays(record.days) }}
      </template>

      <template v-else-if="column.key === 'Status'">
        <div>
          <span class="btn btn-sm btn-white d-inline-flex align-items-center">
            <span
              class="rounded-circle d-flex justify-content-center align-items-center me-2"
              :class="statusBadgeCls(record.status)[0]"
            >
              <i class="ti ti-point-filled" :class="statusBadgeCls(record.status)[1]"></i>
            </span>
            {{ humanStatus(record.status) }}
          </span>
          <div
            v-if="record.decline_reason && (record.status === 'Declined' || record.status === 'Cancelled')"
            class="text-danger fs-12 mt-1"
          >
            {{ record.decline_reason }}
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a
            v-if="record.status === 'New'"
            href="javascript:void(0);"
            class="me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_leaves"
            v-can="'Leaves.Edit'"
            @click="$emit('edit', record)"
          >
            <i class="ti ti-edit"></i>
          </a>
          <a
            v-if="record.status === 'New'"
            href="javascript:void(0);"
            v-can="'Leaves.Delete'"
            @click="$emit('delete', record)"
          >
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>
    </template>
  </a-table>
</template>

<script setup>
import moment from "moment";

defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});

defineEmits(["edit", "delete"]);

const columns = [
  { sorter: false },
  { title: "Leave Type", dataIndex: "leave_type", key: "Leave_Type" },
  { title: "From", dataIndex: "from_date", key: "From" },
  { title: "Approved By", dataIndex: "approved_by_name", key: "Approved_By" },
  { title: "To", dataIndex: "to_date", key: "To" },
  { title: "No of Days", dataIndex: "days", key: "No_of_Days" },
  { title: "Status", dataIndex: "status", key: "Status" },
  { title: "", key: "action" },
];

const STATUS_LABELS = {
  New: "Pending Manager",
  ManagerApproved: "Awaiting HR",
  Approved: "Approved",
  Declined: "Declined",
  Cancelled: "Cancelled",
};

function humanStatus(s) {
  return STATUS_LABELS[s] || s;
}

function statusBadgeCls(s) {
  if (s === "Approved") return ["bg-transparent-success", "text-success"];
  if (s === "Declined") return ["bg-transparent-danger", "text-danger"];
  if (s === "Cancelled") return ["bg-transparent-dark", "text-dark"];
  if (s === "ManagerApproved") return ["bg-transparent-info", "text-info"];
  if (s === "New") return ["bg-transparent-warning", "text-warning"];
  return ["bg-transparent-purple", "text-purple"];
}

function formatDate(d) {
  return d ? moment(d).format("DD MMM YYYY") : "-";
}

function formatDays(days) {
  const n = Number(days ?? 0);
  const label = n === 1 ? "Day" : "Days";
  return `${Number.isInteger(n) ? n : n.toFixed(1)} ${label}`;
}
</script>
